import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiChevronDown } from 'react-icons/fi';
import logo from '../assets/logo.png';
import '../styles/components/Navbar.scss';
import { useTranslation } from 'react-i18next';
import { CiGlobe } from "react-icons/ci";

const Navbar = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [language, setLanguage] = useState(i18n.language || 'en');
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);

  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const toggleLanguageDropdown = () => {
    setShowLanguageDropdown(!showLanguageDropdown);
  };

  const selectLanguage = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    setShowLanguageDropdown(false);
  };

  const getLanguageName = (code) => {
    switch(code) {
      case 'fr': return 'Français';
      case 'en': return 'English';
      case 'de': return 'Deutsch';
      default: return 'Deutsch';
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <Link to="/" className="navbar-logo" onClick={closeMenu}>
            <img src={logo} alt="Powerline Logo" height="32" />
            <span className="navbar-brand">Powerline</span>
          </Link>
        </div>

        {/* Hamburger Icon */}
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FiX /> : <FiMenu />}
        </div>

        {/* Navigation Menu */}
        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className={location.pathname === '/' ? 'nav-item active' : 'nav-item'} onClick={closeMenu}>
            <Link to="/">{t('navbar.home')}</Link>
          </li>
          <li className={location.pathname === '/about' ? 'nav-item active' : 'nav-item'} onClick={closeMenu}>
            <Link to="/about">{t('navbar.about')}</Link>
          </li>
          <li className={location.pathname === '/services' ? 'nav-item active' : 'nav-item'} onClick={closeMenu}>
            <Link to="/services">{t('navbar.services')}</Link>
          </li>
          <li className={location.pathname === '/contact' ? 'nav-item active' : 'nav-item'} onClick={closeMenu}>
            <Link to="/contact">{t('navbar.contact')}</Link>
          </li>
          <li className="nav-item language-selector" onClick={(e) => e.stopPropagation()}>
            <button className="language-button" onClick={toggleLanguageDropdown}>
              <CiGlobe /> {getLanguageName(language)}
              <FiChevronDown className={`dropdown-icon ${showLanguageDropdown ? 'open' : ''}`} />
            </button>
            {showLanguageDropdown && (
              <ul className="language-dropdown">
                <li onClick={() => selectLanguage('de')}>Deutsch</li>
                <li onClick={() => selectLanguage('fr')}>Français</li>
                <li onClick={() => selectLanguage('en')}>English</li>
              </ul>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;